import { render, staticRenderFns } from "./CustomSelect.vue?vue&type=template&id=674ef4e1&scoped=true&"
import script from "./CustomSelect.vue?vue&type=script&lang=js&"
export * from "./CustomSelect.vue?vue&type=script&lang=js&"
import style0 from "./CustomSelect.vue?vue&type=style&index=0&id=674ef4e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674ef4e1",
  null
  
)

export default component.exports